import { CoreDataSecurityApplicationsByIdName } from './name';
import { getDataSecurityApplicationById } from '@api/data-security';
import { updateApplicationReferences } from '../_idMap/actions';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreDataSecurityApplicationsByIdSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateApplicationReferences([
					{
						...response,
						applicationId: request.applicationId
					}
				])
		]
	},
	name: CoreDataSecurityApplicationsByIdName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityApplicationById,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Every
});
